import React, { FC } from 'react';

import { FeatureLimit } from 'models';

import { FeatureLimitTracker } from 'components/feature-limit-tracker/FeatureLimitTracker';

import { useCheckFeatureLimit } from 'hooks/use-check-feature-limit';
import { UnstyledButton } from '@mantine/core';
import { RouterService } from 'services/RouterService';
import { ProjectHelpers } from 'helpers/ProjectHelpers';
import { IoAdd } from 'react-icons/io5';

import cx from './ProjectLimitTracker.module.scss';

const ProjectLimitTracker: FC = () => {
    const { status } = useCheckFeatureLimit(FeatureLimit.PROJECTS);

    return (
        <>
            {(!status || status?.pass) && (
                <UnstyledButton
                    className={cx.create}
                    onClick={() => {
                        RouterService.push(ProjectHelpers.urls.create());
                    }}
                >
                    <IoAdd strokeWidth={1.5} />
                    Create New Project
                </UnstyledButton>
            )}
            {status && !status.pass && (
                <FeatureLimitTracker feature={FeatureLimit.PROJECTS} p="md" h="100%" withBorder radius="md" />
            )}
        </>
    );
};

export { ProjectLimitTracker };
